// Kompletni seznam URL vsech obrazku/hudby appky pro hromadne predstazeni offline hrani (jen v nainstalovane PWA - standalone rezim, viz main.js). require.context bezi pri buildu, takze zname presne hashovane nazvy vystupnich souboru bez vlastniho webpack pluginu.
const imageContext = require.context('@/assets/pic', true, /\.(png|jpe?g|gif|svg|webp)$/);
const audioContext = require.context('@/assets/music', true, /\.mp3$/);

function urlsFrom(context) {
    return context.keys().map((key) => context(key));
}

export function getImageAssetUrls() {
    return urlsFrom(imageContext);
}

export function getMusicAssetUrls() {
    return urlsFrom(audioContext);
}

export function getAllOfflineAssetUrls() {
    return [...getImageAssetUrls(), ...getMusicAssetUrls()];
}

export function isRunningAsInstalledApp() {
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
}

const CONCURRENCY = 6;

// Prochazi predane URL a "sahne" na kazdou pres fetch() - service worker (runtimeCaching, viz vue.config.js) kazdou odpoved ulozi do cache. Uz cachovane soubory se vyresi okamzite bez sitoveho requestu, takze opakovane spusteni jen doplni chybejici a prezije i preruseny prubeh.
async function prefetchUrls(urls, onProgress) {
    let done = 0;
    let index = 0;

    async function worker() {
        while (index < urls.length) {
            const url = urls[index++];
            try {
                await fetch(url);
            } catch (e) {
                // offline/vypadek site - polozka se doplni pri pristim spusteni appky
            }
            done++;
            if (onProgress) {
                onProgress(done, urls.length);
            }
        }
    }

    await Promise.all(Array.from({length: CONCURRENCY}, worker));
}

export async function prefetchAllAssets(onProgress) {
    await prefetchUrls(getAllOfflineAssetUrls(), onProgress);
}

// Samostatne funkce pro Options.vue - hrac si v bezne karte prohlizece muze zapnout predstazeni obrazku a hudby zvlast (429 MB / 81 MB), ne jen dohromady jako u nainstalovane PWA.
export async function prefetchImageAssets(onProgress) {
    await prefetchUrls(getImageAssetUrls(), onProgress);
}

export async function prefetchMusicAssets(onProgress) {
    await prefetchUrls(getMusicAssetUrls(), onProgress);
}
